import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PackContents } from './components/PackContents';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { LaunchOffer } from './components/LaunchOffer';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { WhatsAppButton } from './components/WhatsAppButton';
const TransitionPhrase = () => <div className="mx-auto max-w-3xl px-6 py-4 text-center" data-id="element-0" data-mp="2wiffjcn976y6">
    <p className="font-display text-xl font-[800] italic leading-relaxed text-brand-purpleDark/85 md:text-3xl" data-id="element-1" data-mp="28tw4wqgqei2x">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen w-full bg-brand-surface font-sans text-brand-text selection:bg-brand-purple/25 selection:text-brand-purpleDark" data-id="element-2" data-mp="3ikqwvtvkeu33">
      <UrgencyBanner data-id="element-3" data-mp="3mjg93j4va5l5" />
      <main data-id="element-4" data-mp="3rcj6618urx63">
        <Hero data-id="element-5" data-mp="3rbrbcsn2y3gv" />
        <PackContents data-id="element-6" data-mp="3rdapodp6e4g0" />
        <InitialTestimonials data-id="element-7" data-mp="3rcsxbs5mwadd" />
        <PainPoints data-id="element-8" data-mp="3relwkmdx3sbc" />
        <LaunchOffer data-id="element-9" data-mp="6hrlipoilfp" />
        <MoreTestimonials data-id="element-10" data-mp="4wwnrzgd0hb" />
        <FAQ data-id="element-11" data-mp="56m9egl55mh" />
        <CostComparison data-id="element-12" data-mp="7sulgbavp5r" />
        <TransitionPhrase data-id="element-13" data-mp="2zld4hgdhhrep" />
        <EmotionalClose data-id="element-14" data-mp="2zm4xqkjlzd1t" />
      </main>
      <Footer data-id="element-15" data-mp="2zn6cayzu2hoa" />
      <FloatingNotification data-id="element-16" data-mp="33mouvo46mgny" />
      <WhatsAppButton data-id="element-17" data-mp="33lwzadal4ixo" />
    </div>;
}